import { GlLabel } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { sortBy } from 'lodash-es';
import { isScopedLabel } from '~/lib/utils/common_utils';
export default {
    name: 'EmbeddedLabelsList',
    components: {
        GlLabel
    },
    inject: [
        'allowScopedLabels'
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        selectedLabels: {
            type: Array,
            required: true
        },
        allowLabelRemove: {
            type: Boolean,
            required: true
        },
        supportsLockOnMerge: {
            type: Boolean,
            required: false,
            default: false
        },
        labelsFilterBasePath: {
            type: String,
            required: true
        },
        labelsFilterParam: {
            type: String,
            required: true
        }
    },
    emits: [
        'label-removed'
    ],
    computed: {
        sortedSelectedLabels () {
            return sortBy(this.selectedLabels, (label)=>isScopedLabel(label));
        }
    },
    methods: {
        buildFilterUrl ({ title }) {
            const { labelsFilterBasePath: basePath, labelsFilterParam: filterParam } = this;
            return `${basePath}?${filterParam}[]=${encodeURIComponent(title)}`;
        },
        scopedLabel (label) {
            return this.allowScopedLabels && isScopedLabel(label);
        },
        isLabelLocked (label) {
            // These particular labels were initialized from HAML data, so the attributes are
            // in snake case instead of camel case
            return label.lock_on_merge && this.supportsLockOnMerge;
        },
        showCloseButton (label) {
            return this.allowLabelRemove && !this.isLabelLocked(label);
        },
        removeLabel (labelId) {
            this.$emit('label-removed', labelId);
        }
    }
};
